import React from 'react';

export function TableViewTableSkeleton({ rowCount = 5 }: { rowCount?: number }) {
  const headerClasses = 'px-2 py-2 uppercase text-xs font-semibold';

  return (
    <div id="table-view-skeleton-wrapper" className="bg-white overflow-hidden">
      <div
        id="table-view-skeleton-container"
        className="h-full min-h-0 overflow-y-auto overflow-x-auto"
      >
        <table className="min-w-[787px] text-left text-[10px] animate-pulse">
          <thead className="sticky top-0 bg-gray-100 z-5">
            <tr>
              <th className={headerClasses}>Address</th>
              <th className={headerClasses}>Price</th>
              <th className={headerClasses}>$/SqFt</th>
              <th className={headerClasses}>SqFt</th>
              <th className={headerClasses}>Beds</th>
              <th className={headerClasses}>Baths</th>
              <th className={headerClasses}>Potential Equity</th>
              <th className={headerClasses}>On Market</th>
              <th className={headerClasses}>Favorite</th>
              <th className={headerClasses}>Add to List</th>
            </tr>
          </thead>
          <tbody>
            {[ ...Array(rowCount) ].map((_, i) => (
              <tr key={i} className="odd:bg-white even:bg-gray-50">
                {Array.from({ length: 10 }).map((__, j) => (
                  <td key={j} className="px-3 py-3">
                    <div className="h-4 w-16 bg-gray-200 rounded" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
